export const ANALYTICS_IMAGE_SCROLLED = "ANALYTICS_IMAGE_SCROLLED";
